var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheDroite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_46",
    "data-name": "Groupe 46",
    transform: "translate(-277 -572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 80,
    height: 80,
    transform: "translate(277 572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_43",
    "data-name": "Groupe 43",
    transform: "translate(287 583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 5.779,
    height: 5.779,
    transform: "translate(54.788 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 5.779,
    height: 5.779,
    transform: "translate(54.788 28.893)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 5.779,
    height: 5.779,
    transform: "translate(49.009 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 5.779,
    height: 5.779,
    transform: "translate(49.009 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 5.779,
    height: 5.779,
    transform: "translate(49.009 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 5.779,
    height: 5.779,
    transform: "translate(49.009 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 11.557)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 23.115)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 34.672)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 5.779,
    height: 5.779,
    transform: "translate(43.83 40.451)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 11.557)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 17.336)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 34.672)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 40.451)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.351 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 5.779)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 11.557)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 34.672)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 40.451)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 5.779,
    height: 5.779,
    transform: "translate(32.873 52.009)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 5.779)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 11.557)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 40.451)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.394 52.009)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 11.557)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 17.336)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 34.672)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 40.451)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 5.779,
    height: 5.779,
    transform: "translate(21.915 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.436 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.436 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.436 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.436 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 5.779,
    height: 5.779,
    transform: "translate(10.958 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 5.779,
    height: 5.779,
    transform: "translate(10.958 23.115)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 5.779,
    height: 5.779,
    transform: "translate(10.958 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 5.779,
    height: 5.779,
    transform: "translate(10.958 34.672)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 17.336)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 23.115)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 28.894)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 34.672)",
    fill: "#3d3d3d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDroite);
export default __webpack_public_path__ + "static/media/fleche_droite.74ff209bbb5685cfc70d8f43ee93d4ea.svg";
export { ForwardRef as ReactComponent };